import { render, staticRenderFns } from "./SignalingServers.vue?vue&type=template&id=3bc08f02&"
import script from "./SignalingServers.vue?vue&type=script&lang=js&"
export * from "./SignalingServers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports